export const ROLE_ADMIN = "ADMIN";
export const ROLE_OWNER = "CHALET_OWNER";
export const ROLE_DEVELOPER = "DEVELOPER";
export const ROLE_SUPER_ADMIN = "SUPER_ADMIN";

export function isDeveloperRole(role) {
  return role === ROLE_DEVELOPER || role === ROLE_SUPER_ADMIN;
}

/** Site admin panel access: owner ADMIN or programmer developer roles */
export function isSiteAdminRole(role) {
  return role === ROLE_ADMIN || isDeveloperRole(role);
}
